import Vue from "vue";
import VueOnlinePlugin from "vue-navigator-online";

Vue.use(VueOnlinePlugin);
